import { Route, Navigate, Routes } from 'react-router-dom';
import { CustomerMasterLayout } from './coustomerMasterLayout';

import BankPanCard from './kyc/dashboard/BankPanCard';
import PanCardPage from './kyc/pancard/PanCardPage';
import PanCardDetails from './kyc/pancard/PanCardDetails';
import WrongPanDetail from './kyc/pancard/WrongPanDetail';
import WrongUpi from './kyc/upi/WrongUpi';
import WrongBankDetail from './kyc/bank/WrongBankDetail';
import PanUploded from './kyc/pancard/PanUploded';
import AddBankDetail from './kyc/bank/AddBankDetail';
import AddBankAccount from './kyc/bank/AddBankAccount';
import ReConfirmDetails from './kyc/bank/ReConfirmDetails';
import ReConfirmupiDetails from './kyc/upi/ReConfirmupiDetails';
import ReConfirmPanDetails from './kyc/pancard/ReConfirmPanDetails';
import AddBankDetail1 from './kyc/bank/AddBankDetail1';
import BankDetailsAdded from './kyc/bank/BankDetailsAdded';
import AddUPI from './kyc/upi/AddUPI';
import AddUpiDetails from './kyc/upi/AddUpiDetails';
import Upiupload from './kyc/upi/Upiupload';
import SelectPaymentMethod from './kyc/upi/SelectPaymentMethod';
import HowToFindUpi from './kyc/upi/HowToFindUpi';
import ReConfirmDeleteAccount from './kyc/pancard/ReConfirmDeleteAccount';
import ReConfirmDeleteBankAccount from './kyc/bank/ReConfirmDeleteBankAccount';
import ReConfirmDeleteUpiAccount from './kyc/upi/ReConfirmDeleteUpiAccount';
import ViewPan from './kyc/pancard/ViewPan';
import ViewBank from './kyc/bank/ViewBank';
import ViewUpi from './kyc/upi/ViewUpi';
import NotFound from './customerCard/components/userNotFound';
import { CustomerHeader } from './customer/header';
import { SupportForm } from './customerCard/components/support/supportForms/SupportForm';
import { CashBack } from './customer/cashback';
import RedemptionList from './redemptionCenter/redemptionList';
import RedemnessDashboard from './redemptionCenter/redemness-dashboard';
import RedemDetails from './redemptionCenter/redemDetails';
import RedemTransectionType from './redemptionCenter/redemptionFiles/redemTransectionType';
import RedemReConfirm from './redemptionCenter/redemptionFiles/redemReConfirm';
import SuccessRedemption from './redemptionCenter/redemptionFiles/successRedemption';
import RedemptionError from './redemptionCenter/redemptionFiles/redemptionError';
import { UserRedemList } from './customer/userRedemList';
import { RedemAddress } from './redemptionCenter/address/redemAddress';
import { VoucherHistory } from './redemptionCenter/voucher-history';
import { GiftDetail } from './redemptionCenter/transactionDetail/giftDetail';
import { CommonSupportHome } from './customer/supportFiles/commonSupportHome';
import { CommonSupportForm } from './customer/supportFiles/commonSupportForm';
import { Profile } from './customer/profile';
import RedemptionCategory from './redemptionCenter/category/category';
import RedemptionSubCategory from './redemptionCenter/category/sub-category';
import AddToCartDetail from './carts/addToCartDetail';
import CartDetail from './carts/cart';
import { RedeemHistory } from './redemptionCenter/redeem-history';
import { PagePrivacy, PageTerms } from './customer/page';
import DynamicDashboard from './dashboard';
import { UserPurchaseList } from './customer/purchase';
import SchemeDashboard from './dashboard/schemeDashboard';
import GameDetail from './game/detail';
import NewGameDashboard from './game/newgame';
import DistributorList from './customer/submitPayment/distributor';


const PrivateRoute = () => {



    return <Routes>
        <Route element={<CustomerMasterLayout />}>
            <Route
                path='/scheme-dashboard'
                element={
                    <>
                        <CustomerHeader heading="Schemes" />
                        {/* <CustomerDashboard /> */}
                        <SchemeDashboard />
                    </>
                }
            />
            <Route
                path='/dashboard'
                element={
                    <>
                        <CustomerHeader heading="Dashboard" isUrl={true} />
                        {/* <CustomerDashboard /> */}
                        <DynamicDashboard />
                    </>
                }
            />

            <Route
                path='/profile'
                element={
                    <>
                        <CustomerHeader url={`/customer/dashboard`} heading="Profile" isUrl={true} />
                        <Profile />
                    </>
                }
            />
            <Route
                path='/redemption-center'
                element={
                    <>
                        <CustomerHeader heading="Redemption" url={`/customer/redem-category`} isUrl={true} />
                        <RedemptionList login="customer" />
                    </>
                }
            />
            <Route
                path='/redemption-offer'
                element={
                    <>
                        <CustomerHeader heading="Redemption" url={`/customer/redem-category`} isUrl={true} />
                        <RedemptionList login="customer" />
                    </>
                }
            />
            <Route
                path='/redemption-center/:cid'
                element={
                    <>
                        <CustomerHeader heading="Redemption" isUrl={false} />
                        <RedemptionList login="customer" />
                    </>
                }
            />
            <Route
                path='/redemption-cat-center/:category'
                element={
                    <>
                        <CustomerHeader heading="Redemption" isUrl={false} />
                        <RedemptionList login="customer" />
                    </>
                }
            />
            <Route
                path='/redemption-history'
                element={
                    <>
                        <CustomerHeader heading="Redemption History" url={`/customer/dashboard`} isUrl={true} />
                        <RedeemHistory login="customer" />
                    </>
                }
            />
            <Route
                path='/redemption-voucher-history'
                element={
                    <>
                        <CustomerHeader heading="Voucher History" url={`/customer/dashboard`} isUrl={true} />
                        <VoucherHistory login="customer" />
                    </>
                }
            />
            {/* <Route
                        path='/voucher-detail/:id'
                        element={
                            <>
                                <CustomerHeader heading="Voucher Detail" url={`/customer/redemption-voucher-history`} isUrl={true} />
                                <VoucherDetail login="customer" userData={userData} />
                            </>
                        }
                    /> */}
            <Route
                path='/redem-detail/:redem_id'
                element={
                    <>
                        <CustomerHeader heading="Redemption Detail" isUrl={false} />
                        <RedemDetails login="customer" />
                    </>
                }
            />
            <Route
                path='/redem-category'
                element={
                    <>
                        <CustomerHeader heading="Redemption" url={`/customer/dashboard`} isUrl={true} />
                        <RedemptionCategory login="customer" />
                    </>
                }
            />

            <Route
                path='/redem-sub-category/:id'
                element={
                    <>
                        <CustomerHeader heading="Redemption" url={`/customer/redem-category`} isUrl={true} />
                        <RedemptionSubCategory login="customer" />
                    </>
                }
            />
            <Route
                path='/redem-detail/selectRedem-type/:user_ref'
                element={
                    <>
                        <CustomerHeader heading="Redemption Transaction" url={`/customer/redemption-center`} isUrl={true} />
                        <RedemTransectionType login="customer" />
                    </>
                }
            />
            <Route
                path='/redem-detail/re-confirm/:user_ref'
                element={
                    <>
                        <CustomerHeader heading="Redemption Detail" url={`/customer/redemption-center`} isUrl={true} />
                        <RedemReConfirm login="customer" />
                    </>
                }
            />
            <Route
                path='/redem-addtocart-detail'
                element={
                    <>
                        <CustomerHeader heading="Redemption Detail" isUrl={false} />
                        <AddToCartDetail login="customer" />
                    </>
                }
            />
            <Route
                path='/redem-cart'
                element={
                    <>
                        <CustomerHeader heading="Cart" isUrl={false} />
                        <CartDetail login="customer" />
                    </>
                }
            />
            <Route
                path='/user-redem-transaction/:user_id'
                element={
                    <>
                        <CustomerHeader heading="Your Transaction" url={`/customer/dashboard`} isUrl={true} />
                        <UserRedemList login="customer" />
                    </>
                }
            />
            <Route
                path='/user-redem-detail/:redem_id'
                element={
                    <>
                        <CustomerHeader heading="Redemption Detail" isUrl={false} />
                        <GiftDetail login="customer" />
                    </>
                }
            />

            <Route
                path='/redem-detail/success'
                element={
                    <>
                        <CustomerHeader heading="Redemption Detail" url={`/customer/redemption-center`} isUrl={true} />
                        <SuccessRedemption login="customer" />
                    </>
                }
            />
            <Route
                path='/redem-detail/redem-error/:user_ref'
                element={
                    <>
                        <CustomerHeader heading="Redemption Detail" url={`/customer/redemption-center`} isUrl={true} />
                        <RedemptionError login="customer" />
                    </>
                }
            />
            <Route
                path='/redem-detail/add-address/:user_ref'
                element={
                    <>
                        <CustomerHeader heading="Redemption Detail" url={`/customer/redemption-center`} isUrl={true} />
                        <RedemAddress login="customer" />
                    </>
                }
            />
            <Route
                path='/redemptionness/:user_ref'
                element={
                    <>
                        <CustomerHeader heading="Redemption" url={`/customer/dashboard`} isUrl={true} />
                        <RedemnessDashboard login="customer" />
                    </>
                }
            />
            {/* Other routes with Heading */}
            <Route
                path='/bankpancard-details/:userId'
                element={
                    <>
                        <CustomerHeader heading="Kyc Details" url={'/customer/dashboard'} isUrl={true} />
                        <BankPanCard login="customer" />
                    </>
                }
            />
            <Route
                path='/purchase/:user_id'
                element={
                    <>
                        <CustomerHeader heading="Purchase" url={'/customer/dashboard'} isUrl={true} />
                        <UserPurchaseList login="customer" />
                    </>
                }
            />
            <Route
                path='/pan-card/:userId'
                element={
                    <>
                        <CustomerHeader heading="Add Pan Card" url={`/customer/bankpancard-details`} isUrl={true} />
                        <PanCardPage login="customer" />
                    </>
                }
            />
            <Route
                path='/pancard-details'
                element={
                    <>
                        <CustomerHeader heading="Pan Card Details" url={'/customer/pan-card'} isUrl={false} />
                        <PanCardDetails login="customer" />
                    </>
                }
            />
            <Route
                path='/wrong-pancard-details'
                element={
                    <>
                        <CustomerHeader heading="Wrong Pan Card Details" url={'/customer/pan-card'} isUrl={false} />
                        <WrongPanDetail login="customer" />
                    </>
                }
            />

            <Route
                path='/wrong-upi-details'
                element={
                    <>
                        <CustomerHeader heading="Wrong UPI Details" url={'/customer/pan-card'} isUrl={false} />
                        <WrongUpi login="customer" />
                    </>
                }
            />
            <Route
                path='/wrong-bank-details'
                element={
                    <>
                        <CustomerHeader heading="Wrong Bank Details" url={`/customer/addbank-account`} isUrl={false} />
                        <WrongBankDetail login="customer" />
                    </>
                }
            />
            <Route
                path='/pancard-uploded/:userId'
                element={
                    <>
                        <CustomerHeader heading="Pan Card Uploaded" url={`/customer/bankpancard-details`} isUrl={true} />
                        <PanUploded login="customer" />
                    </>
                }
            />
            <Route
                path='/addbank-detail/:userId'
                element={
                    <>
                        <CustomerHeader heading="Add Bank Detail" url={`/customer/bankpancard-details`} isUrl={true} />
                        <AddBankDetail login="customer" />
                    </>
                }
            />
            <Route
                path='/addbank-account/:userId'
                element={
                    <>
                        <CustomerHeader heading="Add Bank Account" url={`/customer/addbank-detail`} isUrl={true} />
                        <AddBankAccount login="customer" />
                    </>
                }
            />
            <Route
                path='/reconfirm-details/:userId'
                element={
                    <>
                        <CustomerHeader heading="Reconfirm Details" url={`/customer/addbank-account`} isUrl={true} />
                        <ReConfirmDetails login="customer" />
                    </>
                }
            />
            <Route
                path='/reconfirm-upi-details/:userId'
                element={
                    <>
                        <CustomerHeader heading="Reconfirm UPI Details" url={`/customer/add-upi`} isUrl={true} />
                        <ReConfirmupiDetails login="customer" />
                    </>
                }
            />
            <Route
                path='/reconfirm-pan-details/:userId'
                element={
                    <>
                        <CustomerHeader heading="Reconfirm Pan Details" url='/customer/pan-card' />
                        <ReConfirmPanDetails login="customer" />
                    </>
                }
            />
            <Route
                path='/addbank-details/:userId'
                element={
                    <>
                        <CustomerHeader heading="Add Bank Details" url={`/customer/addbank-account`} isUrl={true} />
                        <AddBankDetail1 login="customer" />
                    </>
                }
            />
            <Route
                path="/bankdetails-added/:userId"
                element={
                    <>
                        <CustomerHeader heading="Bank Details Added" url={`/customer/bankpancard-details`} isUrl={true} />
                        <BankDetailsAdded login="customer" />
                    </>
                }
            />
            <Route
                path="/add-upi/:userId"
                element={
                    <>
                        <CustomerHeader heading="Add UPI" url={`/customer/bankpancard-details`} isUrl={true} />
                        <AddUPI login="customer" />
                    </>
                }
            />
            <Route
                path="/add-upi-details"
                element={
                    <>
                        <CustomerHeader heading="Add UPI Details" isUrl={false} />
                        <AddUpiDetails login="customer" />
                    </>
                }
            />
            <Route
                path="/upi-details-success/:userId"
                element={
                    <>
                        <CustomerHeader heading="UPI Details Success" url={`/customer/bankpancard-details`} isUrl={true} />
                        <Upiupload login="customer" />
                    </>
                }
            />
            <Route
                path="/select-payment-method"
                element={
                    <>
                        <CustomerHeader heading="Select Payment Method" />
                        <SelectPaymentMethod login="customer" />
                    </>
                }
            />
            <Route
                path="/page/privacy-policy"
                element={
                    <>
                        <CustomerHeader heading="Privacy Policy" />
                        <PagePrivacy login="customer" />
                    </>
                }
            />
            <Route
                path="/page/terms-condition"
                element={
                    <>
                        <CustomerHeader heading="Terms & Condition" />
                        <PageTerms login="customer" />
                    </>
                }
            />
            <Route
                path="/how-to-find-upi"
                element={
                    <>
                        <CustomerHeader heading="How to Find UPI" />
                        <HowToFindUpi login="customer" />
                    </>
                }
            />
            <Route
                path="/reconfirm-delete-account/:userId"
                element={
                    <>
                        <CustomerHeader heading="Reconfirm Delete Account" />
                        <ReConfirmDeleteAccount login="customer" />
                    </>
                }
            />
            <Route
                path="/reconfirm-delete-bank-account/:userId"
                element={
                    <>
                        <CustomerHeader heading="Reconfirm Delete Bank Account" />
                        <ReConfirmDeleteBankAccount login="customer" />
                    </>
                }
            />
            <Route
                path="/reconfirm-delete-upi-account/:userId"
                element={
                    <>
                        <CustomerHeader heading="Reconfirm Delete UPI Account" />
                        <ReConfirmDeleteUpiAccount login="customer" />
                    </>
                }
            />
            <Route
                path="/view-pan"
                element={
                    <>
                        <CustomerHeader heading="View Pan" />
                        <ViewPan login="customer" />
                    </>
                }
            />
            <Route
                path="/view-bank/:userId"
                element={
                    <>
                        <CustomerHeader heading="View Bank" />
                        <ViewBank login="customer" />
                    </>
                }
            />
            <Route
                path="/view-upi"
                element={
                    <>
                        <CustomerHeader heading="View UPI" />
                        <ViewUpi login="customer" />
                    </>
                }
            />
            <Route
                path="/support/:user_id"
                element={
                    <>
                        <CustomerHeader heading="Support" />
                        <SupportForm login="customer" />
                    </>
                }
            />
            <Route
                path="/common-support"
                element={
                    <>
                        <CustomerHeader url={`/customer/dashboard`} heading="Support" />
                        <CommonSupportHome omelogin="customer" />
                    </>
                }
            />
            <Route
                path="/support-query/:user_id"
                element={
                    <>
                        <CustomerHeader url={`/customer/dashboard`} heading="Support Query" />
                        <CommonSupportForm login="customer" />
                    </>
                }
            />
            <Route
                path="/cashback/:user_id"
                element={
                    <div className='bg-white vh-100'>
                        <CustomerHeader url={`/customer/bankpancard-details`} heading="Cash Back" />
                        <CashBack login="customer" />
                    </div>
                }
            />
            <Route
                path="/redemnessDashboard/:user_id"
                element={
                    <div className='bg-white vh-100'>
                        <CustomerHeader url={`/customer/dashboard`} heading="Redemness Dashboard" />
                        <RedemnessDashboard login="customer" />
                    </div>
                }
            />

            <Route
                path="/not-found"
                element={
                    <>
                        <CustomerHeader heading="Not Found" />
                        <NotFound login="customer" />
                    </>
                }
            />
            {/* Redirect from /customer root to /customer/dashboard */}
            {/* <Route path="/customer" element={<Navigate to="/dashboard" />} /> */}

            {/* Catch-all redirect to /customer/dashboard */}
            <Route path="*" element={<Navigate to="/customer/scheme-dashboard" />} />
            <Route path='game' element={<NewGameDashboard />} />
            <Route path='game/:id' element={<GameDetail />} />
            <Route path='select-distributor' element={<><CustomerHeader heading="Select Distributor" /> <DistributorList /></>} />

            {/* <Route path='*' element={<Navigate to='/error/404' />} /> */}

        </Route>
    </Routes>
};

export default PrivateRoute;
